const actions = {
  LOAD_PAYMENT_LIST: 'LOAD_PAYMENT_LIST',
  LOAD_PAYMENT_LIST_SUCCESS: 'LOAD_PAYMENT_LIST_SUCCESS',
  SAVE_PAYMENT_LIST: 'SAVE_PAYMENT_LIST',

  LOAD_API_ERROR: 'LOAD_API_ERROR',
  SAVE_API_ERROR: 'SAVE_API_ERROR',

  loadPaymentApi: (pagination, data) => {
    return { type: actions.LOAD_PAYMENT_LIST, pagination, data };
  },
  loadPaymentApiSuccess: (pagination, data) => ({
    type: actions.LOAD_PAYMENT_LIST_SUCCESS,
    payload: { pagination, data }
  }),
  loadApiError: (error) => ({
    type: actions.LOAD_API_ERROR,
    payload: { error }
  }),
  saveApiError: (error) => ({
    type: actions.SAVE_API_ERROR,
    payload: { error }
  })
};

export default actions;
